/**
 * POWRÓT PO LOGOWANIU (zgłoszenie Maćka 19.10). Wylogowany człowiek, który otwiera
 * `/profile` (zakładka, link z maila, przeładowanie po wyczyszczeniu danych witryny), dostawał
 * „404 Page not found”: trasy dla zalogowanych istnieją w routerze tylko przy sesji, więc bez
 * niej adres wpadał w `*`. Strona istnieje — brakuje logowania. Wysyłamy na `/login`,
 * zapamiętujemy adres, a `OnboardingRouter` (Konwencja 9) oddaje go DOPIERO wtedy, gdy sam
 * skierowałby człowieka na jego zwykłą stronę startową — nigdy z pominięciem kroku
 * onboardingu ani bramki roli.
 *
 * Wzorzec jak `adminReturn.ts`: localStorage (link z maila otwiera nową kartę, OAuth wraca
 * przez przeładowanie), jednorazowy odbiór, wartość ograniczona do listy tras — podrobiony
 * wpis nie przekieruje nigdzie indziej. `/admin/*` ma własny mechanizm w `AdminGate`.
 */
const KLUCZ = 'flathero.powrot_po_logowaniu';

/**
 * Trasy z gałęzi `session ? …` w `App.tsx`, na które warto wrócić. `/onboarding/*` i
 * `/login-success` też wymagają sesji, ale tam o celu decyduje `OnboardingRouter`.
 * Nowa trasa tylko dla zalogowanych → dopisz ją tutaj (inaczej wylogowany zobaczy 404).
 */
const TRASY_DO_POWROTU: RegExp[] = [
  /^\/profile$/,
  /^\/settings$/,
  /^\/notifications$/,
  /^\/messages$/,
  /^\/claim\/success$/,
  /^\/owner\/.+/,
  // Linki z alertów e-mail (audyt 19.10): bez sesji logowanie, potem z powrotem na wyniki z zestawem.
  /^\/alerty-mieszkan\/(wyniki|filtry)$/,
];
const TRASY_ROUTERA: RegExp[] = [/^\/onboarding\/.+/, /^\/login-success$/];

const bezUkosnikaNaKoncu = (p: string) => (p.length > 1 ? p.replace(/\/+$/, '') : p);

/** Czy ścieżka istnieje tylko dla zalogowanych (wylogowany ma trafić na logowanie, nie 404). */
export function czyTrasaTylkoDlaZalogowanych(sciezka: string): boolean {
  const p = bezUkosnikaNaKoncu(sciezka);
  return [...TRASY_DO_POWROTU, ...TRASY_ROUTERA].some((w) => w.test(p));
}

function czyCelPowrotu(cel: string | null): cel is string {
  if (!cel || !cel.startsWith('/') || cel.startsWith('//')) return false;
  try {
    const url = new URL(cel, 'http://x');
    if (url.origin !== 'http://x') return false;
    return TRASY_DO_POWROTU.some((w) => w.test(bezUkosnikaNaKoncu(url.pathname)));
  } catch {
    return false;
  }
}

export function zapamietajPowrot(cel: string): void {
  try {
    if (czyCelPowrotu(cel)) localStorage.setItem(KLUCZ, cel);
  } catch {
    // zablokowane dane witryny — po logowaniu wyląduje na swojej stronie startowej
  }
}

/** Odbierz i wyczyść: wpis przeżywa dokładnie jedno logowanie. */
export function odbierzPowrot(): string | null {
  try {
    const v = localStorage.getItem(KLUCZ);
    localStorage.removeItem(KLUCZ);
    return czyCelPowrotu(v) ? v : null;
  } catch {
    return null;
  }
}
